module.exports = __webpack_public_path__ + "static/right-background-570e9022e1befd8957d8e6c6504b42d2.png";